export enum TIMESHEET_KEYS {
    CURRENT_TIMESHEET = 'currentTimesheet',
    SUBMITTED_TIMESHEET = 'submittedTimesheet',
    ALL_TIMESHEET = 'allTimesheets',
}
